import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMobilemenu } from "../hooks/lib/useMobilemenu";
import { useStickyHeader } from "../hooks/lib/useStickyHeader";
import { HeaderSearch } from "./HeaderSearch";
import { useMobile } from "../hooks/custom/useMobile";
import useTab from "../hooks/custom/useTab";
import { HeaderSidebar } from "./HeaderSidebar";
import AcademicsMegaMenu from "./AcademicsMegaMenu";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";
import { useBrochureContext } from "../context/BrochureContext";
import { PdfViwer } from "./PdfViwer";
import {
  IAcademicsMenuCoursesData,
  IAcademicsMenuProgramsData,
} from "../exports/interfaces";
import {
  fetchAcademicsMenuCourses,
  fetchAcademicsMenuPrograms,
} from "../api/HomeApi";
import { dynamicFailed } from "../hooks/custom/useToast";
// import { HeaderLanguage } from "./HeaderLanguage";

export const Header = () => {
  const { companyDetailsData } = useCompanyDetailsContext();
  const { brochureData } = useBrochureContext();
  useMobilemenu();
  useStickyHeader();
  const mobile = useMobile();
  const tab = useTab();

  const [showSidebar, setShowSidebar] = useState(false);
  const [openPdf, setOpenPdf] = useState(false);
  const [pdfPath, setPdfPath] = useState("");

  const openViewer = (path: string) => {
    setPdfPath(path);
    setOpenPdf(true);
  };

  const closeViewer = () => setOpenPdf(false);
  const toggleSidebar = () => setShowSidebar((v) => !v);

  // const [showHighlightsMenu, setShowHighlightsMenu] = useState(false);
  const [showPhoneMenu, setShowPhoneMenu] = useState(false);

  useEffect(() => {
    const sidebar = document.getElementById("sidebar");

    const toggleBodyScroll = () => {
      if (sidebar?.classList.contains("td_active")) {
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
      } else {
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.width = "";
      }
    };

    const observer = new MutationObserver(toggleBodyScroll);
    if (sidebar) {
      observer.observe(sidebar, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    return () => {
      observer.disconnect();
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
    };
  }, []);

  useEffect(() => {
    const sidebar = document.getElementById("sidebar");
    const menus = sidebar?.querySelectorAll(
      "li.menu-item-has-children:not(.td_mega_menu) > ul",
    );

    menus?.forEach((ul) => {
      ul.addEventListener("click", (e) => {
        const target = e.target as HTMLElement;

        // only close when clicking real navigation link
        if (target.tagName === "A") {
          closeSidebar();
        }
      });
    });

    return () => {
      menus?.forEach((ul) => {
        ul.removeEventListener("click", closeSidebar);
      });
    };
  }, []);

  const closeSidebar = () => {
    const sidebar = document.getElementById("sidebar");
    sidebar?.classList.remove("td_active");

    document.querySelector(".td_menu_toggle")?.remove();

    document
      .querySelectorAll(".td_munu_dropdown_toggle.active")
      .forEach((el) => el.classList.remove("active"));
  };

  const location = useLocation();
  const navigate = useNavigate();

  // const handleNewsClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  //   if (location.pathname === "/") {
  //     e.preventDefault();
  //     document
  //       .getElementById("news-events")
  //       ?.scrollIntoView({ behavior: "smooth" });
  //   }
  // };

  const handleMenuClick = (
    e: React.MouseEvent<HTMLElement>,
    pathname: string,
    hash: string,
  ) => {
    e.preventDefault();
    closeSidebar();

    if (
      location.pathname === `/${pathname}` ||
      (pathname === "" && location.pathname === "/")
    ) {
      document.getElementById(hash)?.scrollIntoView({
        behavior: "smooth",
      });
    } else {
      navigate(`/${pathname}#${hash}`);
    }
  };

  const handleMenuClickToTab = (
    e: React.MouseEvent<HTMLAnchorElement>,
    pathname: string,
    hash: string,
    idToScroll?: string,
  ) => {
    e.preventDefault();

    closeSidebar();

    const targetHash = `#${hash}`;

    if (location.pathname === `/${pathname}`) {
      // update URL hash
      window.history.replaceState(null, "", targetHash);

      // activate tab
      const tabLink = document.querySelector(
        `.td_tab_links a[href="${targetHash}"]`,
      ) as HTMLAnchorElement | null;

      tabLink?.click();

      // scroll to tabs
      document.querySelector(idToScroll || ".td_tabs")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      navigate(`/${pathname}${targetHash}`);
    }
  };

  const [academicsMenuPrograms, setAcademicsMenuPrograms] = useState<
    IAcademicsMenuProgramsData[]
  >([]);
  const [academicsMenuCourses, setAcademicsMenuCourses] = useState<
    IAcademicsMenuCoursesData[]
  >([]);

  useEffect(() => {
    Promise.all([fetchAcademicsMenuPrograms(), fetchAcademicsMenuCourses()])
      .then(([academicsMenuProgramsData, AcademicsMenuCoursesData]) => {
        setAcademicsMenuPrograms(academicsMenuProgramsData);
        setAcademicsMenuCourses(AcademicsMenuCoursesData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      });
  }, []);

  return (
    <>
      <header
        className="td_site_header td_style_1 td_type_2 td_sticky_header td_medium td_heading_color"
        style={{ boxShadow: "unset", backgroundColor: "unset" }}
      >
        <div className="td_top_header td_top_heading_bg">
          <div className="container">
            <div className="td_top_header_in">
              <div className="td_top_header_left"></div>
              <div className="td_top_header_right td_fs_14">
                <ul className="td_header_contact_list td_mp_0 td_normal">
                  <li
                    style={{
                      position: "relative",
                    }}
                    // onMouseEnter={() => setShowHighlightsMenu(true)}
                    // onMouseLeave={() => setShowHighlightsMenu(false)}
                  >
                    <Link
                      to="/community-university#ways-to-give"
                      className="td_opacity_7"
                      onClick={(e) =>
                        handleMenuClick(
                          e,
                          "community-university",
                          "ways-to-give",
                        )
                      }
                    >
                      <span>Give</span>
                      <i
                        className="fa fa-heart orange-color "
                        style={{
                          marginLeft: "4px",
                          fontSize: "10px",
                          verticalAlign: "center",
                        }}
                      ></i>
                    </Link>
                  </li>

                  <li
                    style={{
                      position: "relative",
                    }}
                    onMouseEnter={() => setShowPhoneMenu(true)}
                    onMouseLeave={() => setShowPhoneMenu(false)}
                  >
                    <a
                      href={`tel:${companyDetailsData[0]?.telephone_number}`}
                      className="td_opacity_7"
                    >
                      {companyDetailsData[0]?.telephone_number}{" "}
                      <i
                        className="fa fa-angle-down"
                        style={{
                          marginLeft: "4px",
                          fontSize: "10px",
                          verticalAlign: "center",
                        }}
                      ></i>
                    </a>
                    {showPhoneMenu && (
                      <ul className="header-sub-menu">
                        <li>
                          <a
                            href={`tel:${companyDetailsData[0]?.telephone_number}`}
                            className="header-dropdown-item"
                          >
                            {companyDetailsData[0]?.telephone_number}
                          </a>
                        </li>
                        <li>
                          <a
                            href={`tel:${companyDetailsData[0]?.mobile_number}`}
                            className="header-dropdown-item"
                          >
                            {companyDetailsData[0]?.mobile_number}
                          </a>
                        </li>
                      </ul>
                    )}
                  </li>

                  <li className="td_opacity_7">
                    <a href={`mailto:${companyDetailsData[0]?.email}`}>
                      {companyDetailsData[0]?.email}
                    </a>
                  </li>
                  <li className="td_opacity_7">
                    <a
                      href={companyDetailsData[0]?.get_direction}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {companyDetailsData[0]?.company_address}
                    </a>
                  </li>
                  <li className="td_opacity_7">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <a
                        href={companyDetailsData[0]?.facebook_link}
                        className="td_center"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                      <a
                        href={companyDetailsData[0]?.instagram_link}
                        className="td_center"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                      <a
                        href={companyDetailsData[0]?.x_link}
                        className="td_center"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-x-twitter"></i>
                      </a>
                      <a
                        href={companyDetailsData[0]?.linkedin_link}
                        className="td_center"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-brands fa-linkedin"></i>
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="td_main_header">
          <div className="container">
            <div className="td_main_header_in">
              <div className="td_main_header_left">
                <Link
                  to="/"
                  className="td_site_branding"
                  onClick={closeSidebar}
                >
                  <img
                    src={`${process.env.REACT_APP_cmsUrl}/uploads/${companyDetailsData[0]?.primary_logo_color[0]?.media?.name}`}
                    alt="Logo"
                    className="logo-img"
                  />
                </Link>
              </div>
              <div className="td_main_header_center">
                <nav className="td_nav">
                  <div className="td_nav_list_wrap" id="sidebar">
                    <div className="td_nav_list_wrap_in">
                      <ul className="td_nav_list">
                        <li>
                          <Link
                            to="/"
                            className="td_accent_color"
                            style={{ fontWeight: "bold" }}
                            onClick={closeSidebar}
                          >
                            Home
                          </Link>
                        </li>
                        <li className="menu-item-has-children td_mega_menu">
                          <Link
                            to="/about"
                            style={{ fontWeight: "bold" }}
                            onClick={closeSidebar}
                          >
                            About
                          </Link>
                          <ul className="td_mega_wrapper">
                            <li className="menu-item-has-children">
                              <h4>Introduction</h4>
                              <ul>
                                <li>
                                  <Link
                                    to="/about#introduction1"
                                    onClick={(e) =>
                                      handleMenuClick(
                                        e,
                                        "about",
                                        "introduction",
                                      )
                                    }
                                  >
                                    Our Story
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="/about#why-unepal"
                                    onClick={(e) =>
                                      handleMenuClick(e, "about", "why-unepal")
                                    }
                                  >
                                    Why UNepal?
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="/about#vision-mission"
                                    onClick={(e) =>
                                      handleMenuClick(
                                        e,
                                        "about",
                                        "vision-mission",
                                      )
                                    }
                                  >
                                    Vision, Mission & Core Values
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      closeSidebar();
                                      openViewer(
                                        brochureData[0]?.file &&
                                          brochureData[0]?.file.length > 0
                                          ? brochureData[0]?.file[0]?.media?.url
                                          : brochureData[0]?.link,
                                      );
                                    }}
                                  >
                                    Our Brochure
                                  </Link>
                                </li>
                              </ul>
                            </li>
                            <li className="menu-item-has-children">
                              <h4>Academic Philosophy</h4>
                              <ul>
                                <li>
                                  <Link
                                    to="/about"
                                    // to="/about#td_tab_3"
                                    // onClick={(e) =>
                                    //   handleMenuClickToTab(
                                    //     e,
                                    //     "about",
                                    //     "td_tab_3"
                                    //   )
                                    // }
                                  >
                                    Liberal Arts & Sciences
                                  </Link>
                                </li>
                              </ul>
                            </li>
                            <li className="menu-item-has-children">
                              <h4>Leadership</h4>
                              <ul>
                                <li>
                                  <Link
                                    to="/about#td_message_tab_1"
                                    onClick={(e) =>
                                      handleMenuClickToTab(
                                        e,
                                        "about",
                                        "td_message_tab_1",
                                        ".td_message_tabs",
                                      )
                                    }
                                  >
                                    Chancellor Message
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="/about#td_message_tab_2"
                                    onClick={(e) =>
                                      handleMenuClickToTab(
                                        e,
                                        "about",
                                        "td_message_tab_2",
                                        ".td_message_tabs",
                                      )
                                    }
                                  >
                                    Vice Chancellor Message
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="/about#board-of-trustees"
                                    onClick={(e) =>
                                      handleMenuClick(
                                        e,
                                        "about",
                                        "board-of-trustees",
                                      )
                                    }
                                  >
                                    BoT and Executives Information
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/advisors" onClick={closeSidebar}>
                                    World-Class Academic Standards & Advisors
                                  </Link>
                                </li>
                              </ul>
                            </li>
                            <li className="menu-item-has-children">
                              <h4>Act</h4>
                              <ul>
                                <li>
                                  <Link
                                    to={`${process.env.REACT_APP_URL}/uploads/announcements/%E0%A4%A8%E0%A5%87%E0%A4%AA%E0%A4%BE%E0%A4%B2%20%E0%A4%B5%E0%A4%BF%E0%A4%B6%E0%A5%8D%E0%A4%B5%E0%A4%B5%E0%A4%BF%E0%A4%A6%E0%A5%8D%E0%A4%AF%E0%A4%BE%E0%A4%B2%E0%A4%AF%20%E0%A4%90%E0%A4%A8,%20%E0%A5%A8%E0%A5%A6%E0%A5%AE%E0%A5%A7.pdf`}
                                    target="_blank"
                                    rel="noreferrer noopener"
                                    onClick={closeSidebar}
                                  >
                                    Act & Policy
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to={`${process.env.REACT_APP_URL}/uploads/announcements/मनोनयनका%20लागि%20सिफारिस%20सम्बन्धी%20नियमावली,%20२०८१.pdf`}
                                    target="_blank"
                                    rel="noreferrer noopener"
                                    onClick={closeSidebar}
                                  >
                                    Rules & Regulations
                                  </Link>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                        <li className="menu-item-has-children custom-accordion">
                          <Link
                            to="/sast"
                            style={{ fontWeight: "bold" }}
                            onClick={closeSidebar}
                          >
                            Academics
                          </Link>
                          <AcademicsMegaMenu
                            closeSidebar={closeSidebar}
                            openViewer={openViewer}
                            academicsMenuPrograms={academicsMenuPrograms}
                            academicsMenuCourses={academicsMenuCourses}
                          />
                        </li>
                        <li className="menu-item-has-children">
                          <Link
                            to="/"
                            className="td_accent_color"
                            style={{ fontWeight: "bold" }}
                            onClick={closeSidebar}
                          >
                            Admissions & Aids
                          </Link>
                          <ul>
                            <li>
                              <Link to="/sast" onClick={closeSidebar}>
                                Undergraduate
                              </Link>
                            </li>
                            <li>
                              <Link to="/mpp" onClick={closeSidebar}>
                                Graduate
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/application-form#financial-aid"
                                // to="/mpp#td_tab_5"
                                // onClick={(e) =>
                                //   handleMenuClickToTab(e, "mpp", "td_tab_5")
                                // }
                              >
                                Financial Aid & Scholarships
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/application-form"
                                onClick={closeSidebar}
                              >
                                Apply Now
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li className="menu-item-has-children">
                          <Link
                            to="#notice_tab_1"
                            className="td_accent_color"
                            style={{ fontWeight: "bold" }}
                            onClick={(e) =>
                              handleMenuClickToTab(
                                e,
                                "",
                                "notice_tab_1",
                                ".td_notice_tabs",
                              )
                            }
                          >
                            Public Notice
                          </Link>
                          <ul>
                            <li className="menu-item-has-children">
                              <Link
                                to="/vacancy"
                                onClick={closeSidebar}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                Vacancy
                                <i
                                  className="fa-solid fa-angle-right"
                                  style={{ fontSize: "10px" }}
                                ></i>
                              </Link>
                              <ul>
                                <li>
                                  <Link
                                    to="/vacancy#academic"
                                    onClick={closeSidebar}
                                  >
                                    Academic Post
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="/vacancy#admin"
                                    onClick={closeSidebar}
                                  >
                                    Admin Post
                                  </Link>
                                </li>
                              </ul>
                            </li>
                            <li>
                              <Link
                                to="#notice_tab_3"
                                onClick={(e) =>
                                  handleMenuClickToTab(
                                    e,
                                    "",
                                    "notice_tab_3",
                                    ".td_notice_tabs",
                                  )
                                }
                              >
                                Procurement Notice
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#notice_tab_4"
                                onClick={(e) =>
                                  handleMenuClickToTab(
                                    e,
                                    "",
                                    "notice_tab_4",
                                    ".td_notice_tabs",
                                  )
                                }
                              >
                                Expression of Interest
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#notice_tab_5"
                                onClick={(e) =>
                                  handleMenuClickToTab(
                                    e,
                                    "",
                                    "notice_tab_5",
                                    ".td_notice_tabs",
                                  )
                                }
                              >
                                Others
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li className="menu-item-has-children">
                          <Link
                            to="/community-university"
                            className="td_accent_color"
                            style={{ fontWeight: "bold" }}
                            onClick={closeSidebar}
                          >
                            Community
                          </Link>
                          <ul>
                            <li>
                              <Link
                                to="/community-university"
                                onClick={closeSidebar}
                              >
                                Building for Future
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/community-faculty"
                                onClick={closeSidebar}
                              >
                                Join as Faculty
                              </Link>
                            </li>
                            <hr />
                            <li>
                              <Link
                                to="/community-university#campus-idea"
                                onClick={(e) =>
                                  handleMenuClick(
                                    e,
                                    "community-university",
                                    "campus-idea",
                                  )
                                }
                              >
                                Our Idea of Campus as Community
                              </Link>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <Link
                            to="/contact"
                            className="td_accent_color"
                            style={{ fontWeight: "bold" }}
                            onClick={closeSidebar}
                          >
                            Contact
                          </Link>
                        </li>
                      </ul>
                      {(mobile || tab) && (
                        <div className="div-give-button">
                          <Link
                            to="/community-university#ways-to-give"
                            className="td_btn td_style_1 td_radius_10 td_medium"
                            onClick={(e) =>
                              handleMenuClick(
                                e,
                                "community-university",
                                "ways-to-give",
                              )
                            }
                          >
                            <span className="td_btn_in td_white_color give_btn">
                              <span>Give</span>
                              <i className="fa fa-heart"></i>
                            </span>
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                </nav>
              </div>
              <div className="td_main_header_right">
                <div className="td_header_btns">
                  {/* {!mobile && !tab && (
                    <Link
                      to="/community-university#ways-to-give"
                      className="td_btn td_style_1 td_radius_10 td_medium"
                      onClick={(e) =>
                        handleMenuClick(
                          e,
                          "community-university",
                          "ways-to-give",
                        )
                      }
                    >
                      <span className="td_btn_in td_white_color give_btn">
                        <span>Give</span>
                        <i className="fa fa-heart"></i>
                      </span>
                    </Link>
                  )} */}
                  {/* <HeaderLanguage /> */}
                  <HeaderSearch />
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <button
                      className="td_hamburger_btn"
                      style={{ color: "#2f2b75" }}
                      onClick={toggleSidebar}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Link to="/application-form">
          <div className="td_bottom_heading_bg">
            <div className="ticker">
              <div className="ticker-track">
                <strong>
                  Admissions Open for Undergraduate Programs - Fall 2026. Apply
                  Now.
                </strong>
              </div>
            </div>
          </div>
        </Link>
      </header>
      <HeaderSidebar
        showSidebar={showSidebar}
        toggleSidebar={toggleSidebar}
        openViewer={openViewer}
        academicsMenuPrograms={academicsMenuPrograms}
        academicsMenuCourses={academicsMenuCourses}
      />
      <PdfViwer open={openPdf} onClose={closeViewer} path={pdfPath} />
    </>
  );
};
